import { render, staticRenderFns } from "./PannelSix.vue?vue&type=template&id=2bf7480a&scoped=true&"
import script from "./PannelSix.vue?vue&type=script&lang=js&"
export * from "./PannelSix.vue?vue&type=script&lang=js&"
import style0 from "./PannelSix.vue?vue&type=style&index=0&id=2bf7480a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7480a",
  null
  
)

export default component.exports